import { SET_LOADING_OFF_ACTION, SET_LOADING_ON_ACTION } from "./reducersConstants";

export const setLoadingOnAction = () => {
  return {
    type: SET_LOADING_ON_ACTION,
  };
};

export const setLoadingOffAction = () => {
  return {
    type: SET_LOADING_OFF_ACTION,
  };
};

export const loadingReducer = (previousState = false, { type }) => {
  switch (type) {
    case SET_LOADING_ON_ACTION:
      return true;
    case SET_LOADING_OFF_ACTION:
      return false;
    default:
      return previousState;
  }
};
